/**
 *  All api related to points history
 */
import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchStoredValueTransactions(options) {
  const { page = 1, ...others } = options
  const params = {
    page,
    includes: ['description'],
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchStoredValueTransactions',
    () => source.cancel('fetchStoredValueTransactions: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'stored_value_transactions',
      method: 'get',
      params,
      arrayFormat: 'brackets',
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      storedValueTransactions: data.storedValueTransactions,
      pagination: data.storedValueTransactionsPagination,
      next: _.get(data, 'storedValueTransactionsPagination.nextPage') > page
        ? () => fetchStoredValueTransactions({ page: page + 1, ...others })
        : null,
      count: _.get(data, 'storedValueTransactionsPagination.totalCount')
    }))
}
